// extracted by mini-css-extract-plugin
export default {"disabled":"EventTarget_disabled__6fPUH"};